import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import UsageStatistics from '../reports/usage_statistics/UsageStatistics';

class Dashboard extends Component {

  render() {
    return (
      <div>
        <Container className="waa-container">
         <UsageStatistics pageName="DASHBOARD"/>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
})

export default withRouter(connect(mapStateToProps)(Dashboard))